export default __webpack_public_path__ + "static/dacs02-a95af5cd3e70de05344e7792aac19e17.jpg";